import { render, staticRenderFns } from "./EntityItemDetail.vue?vue&type=template&id=38196397&scoped=true"
import script from "./EntityItemDetail.vue?vue&type=script&lang=js"
export * from "./EntityItemDetail.vue?vue&type=script&lang=js"
import style0 from "./EntityItemDetail.vue?vue&type=style&index=0&id=38196397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38196397",
  null
  
)

export default component.exports